import { useState } from "react";

import { withCacheBuster } from "../utils/cacheBuster";
import type { ProfileShortcut } from "../types/profileShortcuts";

type ShortcutIconFields = Pick<ProfileShortcut, "icon" | "iconCacheBust">;

// Display URL; withCacheBuster replaces any persisted t= with iconCacheBust.
export function getShortcutIconDisplaySrc(
  shortcut: ShortcutIconFields,
): string | null {
  const assetUrl = shortcut.icon;
  if (!assetUrl) return null;
  if (shortcut.iconCacheBust != null) {
    return withCacheBuster(assetUrl, shortcut.iconCacheBust);
  }
  return assetUrl;
}

// Shared by ShortcutRow and ProfileActionCard; key includes bust so replace-uploads retry after a load error.
export function useShortcutIconSrc(shortcut: ShortcutIconFields) {
  const displaySrc = getShortcutIconDisplaySrc(shortcut);
  const displayKey = `${shortcut.icon ?? ""}|${shortcut.iconCacheBust ?? ""}`;
  const [failedKey, setFailedKey] = useState<string | null>(null);
  const showImage = Boolean(displaySrc) && displayKey !== failedKey;

  return {
    displaySrc,
    displayKey,
    showImage,
    onImageError: () => setFailedKey(displayKey),
  };
}
